import { NgModule } from '@angular/core';
import { GtmIdDirective } from './gtm-id.directive';
import { GtmService } from './gtm.service';

@NgModule({
    declarations: [
        GtmIdDirective
    ],

    providers: [
        GtmService
    ],

    exports: [
        GtmIdDirective
    ]
})
export class GtmModule {}
